/* eslint-disable @stencil-community/required-jsdoc */
import { Memoize, parseIfString } from '@springbokagency/stencil-base';
import { Component, Host, h, Prop } from '@stencil/core';

import type { EfbButton } from '../../atoms/button/button';

@Component({
  tag: 'efb-social-links',
  styleUrl: 'social-links.scss',
  shadow: true,
})
export class EfbSocialLinks {
  /**
   * Props.
   */
  @Prop() data: EfbButton[] | string;

  @Memoize('data')
  get parsedData(): EfbButton[] {
    return parseIfString(this.data);
  }

  /**
   * Render
   */

  render() {
    return (
      <Host>
        <ul class="social-links">
          {this.parsedData.map((item) => (
            <li class="social-links-item">
              <efb-button compact variant="purple" target="_blank" {...item} />
            </li>
          ))}
        </ul>
      </Host>
    );
  }
}
